import { Descriptions, Typography } from 'antd';
import * as moment from 'moment';
import React from 'react';

const { Title, Paragraph, Text } = Typography;
const descriptionProps = {
  style: { paddingTop: 24 },
  column: 1,
  size: 'small',
  bordered: true,
  labelStyle: { width: 100 }
};
const AmpliacionLanding = ({ inspeccion, ampliacion }) => {
  const fecha = moment(inspeccion?.fecha_subida_fotos).format('DD/MM/YYYY');
  return (
    <div style={{ textAlign: 'left' }}>
      <>
        <Descriptions title="Asegurado/a" {...descriptionProps}>
          <Descriptions.Item label="Nombre:">
            {inspeccion?.solicitud?.cotizacion?.persona.nombres || ''}
          </Descriptions.Item>
        </Descriptions>
        <br />
        <Title level={5}>
          Gracias por contratar la cobertura para el seguro del vehículo:
        </Title>
        <Descriptions {...descriptionProps}>
          <Descriptions.Item label="Marca">
            {inspeccion?.solicitud?.cotizacion?.vehiculo.marca.descripcion ||
              ''}
          </Descriptions.Item>
          <Descriptions.Item label="Modelo">
            {inspeccion?.solicitud?.cotizacion?.vehiculo.modelo.descripcion ||
              ''}
          </Descriptions.Item>
          <Descriptions.Item label="Chapa">
            {inspeccion?.solicitud?.cotizacion?.vehiculo.chapa || ''}
          </Descriptions.Item>
        </Descriptions>
      </>
      <br />
      <Title level={5}>
        Luego de analizar las fotografías subidas el día
        {` ${fecha}`}, el inspector está solicitando nuevas fotografías de las
        siguientes partes del vehículo:
      </Title>
      <Paragraph>
        <ol>
          {ampliacion?.map(function test(ampliacionParam) {
            return (
              <li>
                <span>{`${ampliacionParam.parte}`}</span>
              </li>
            );
          })}
        </ol>
      </Paragraph>
      <Title level={4}>
        Para activar la cobertura favor realizar la inspección siguiendo las
        instrucciones:
      </Title>

      <Paragraph>
        <ol>
          <li>Aceptar mantener activada la ubicación</li>
          <li>Tomar las Fotografías con buena iluminación</li>
          <li>
            Captar la <Text strong>totalidad</Text> del vehículo
          </li>
        </ol>
      </Paragraph>
    </div>
  );
};

export default AmpliacionLanding;
